export default __webpack_public_path__ + "static/media/Group 427319027.0905dee2.png";